/* Park Friends: keep the product page's offer ladder telling the truth.
   ---------------------------------------------------------------------------------------
   The block is rendered by snippets/pf-offer.liquid, so it is right on load and right on
   every full page view. Two things happen without a page view, and this file handles both:

     the cart changes    assets/cart.js re-fetches the page but swaps only the drawer's body
                         and footer, so the product page would keep the sentence it was born
                         with ("Add 1 more jersey, save 25%") while the drawer moves on.
     the size changes    these jerseys are priced by size, and product.js does not replace
                         the block, so the rungs would keep quoting the size the page loaded
                         with while the price above them shows another one.

   Neither the ladder nor any money is computed here. The same snippet writes the tiers and
   the wording into the block as JSON, and every per-variant figure as a money string Liquid
   already formatted, so there is one source and no currency is assembled in the browser. */
(function () {
  'use strict';

  var BLOCK = '[data-pf-ladder]';
  /* What the last look at the cart said. Kept so a size change can re-quote the block
     straight away instead of waiting on another round trip. */
  var lastQty = null;

  function config(block) {
    var el = block.querySelector('[data-pf-ladder-config]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function prices(block) {
    var el = block.querySelector('[data-pf-ladder-prices]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* The size picker changes the price, and these jerseys are priced by size: Sucios 619 is
     $89.99 up to Womens and $99.99 at Mens. Every rung is re-quoted from the money strings
     Liquid already formatted for that variant, so the block never contradicts the price
     shown above it and no currency is assembled here. */
  function repriceTo(block, variantId) {
    var map = prices(block);
    var row = map && map[String(variantId)];
    if (!row) return;
    block.setAttribute('data-pf-base-money', row.b);
    var rungs = block.querySelectorAll('[data-pf-rung-index]');
    for (var i = 0; i < rungs.length; i++) {
      var idx = parseInt(rungs[i].getAttribute('data-pf-rung-index'), 10) - 1;
      var money = row.e[idx];
      if (!money) continue;
      rungs[i].setAttribute('data-pf-each', money);
      var out = rungs[i].querySelector('[data-pf-each-out]');
      if (out) out.textContent = money;
    }
  }

  /* The rung the cart is standing on, and the one above it. Same rules as the Liquid:
     the tiers are read in order, the last one is open-ended. */
  function line(cfg, qty) {
    var tiers = cfg.tiers || [];
    if (!tiers.length) return null;
    var top = tiers[tiers.length - 1];

    if (qty >= top.qty) {
      return { text: (cfg.top || '').replace('[pct]', top.pct), atTop: true, reached: top.qty };
    }
    var next = null;
    for (var i = 0; i < tiers.length; i++) {
      if (qty < tiers[i].qty) { next = tiers[i]; break; }
    }
    if (!next) return null;
    var n = next.qty - qty;
    var noun = cfg.noun || 'jersey';
    var tpl = qty > 0 ? (cfg.next || '') : (cfg.first || '');
    var reached = 0;
    for (var j = 0; j < tiers.length; j++) { if (qty >= tiers[j].qty) reached = tiers[j].qty; }
    return {
      text: tpl.replace('[n]', n).replace('[noun]', n > 1 ? noun + 's' : noun).replace('[pct]', next.pct),
      atTop: false,
      reached: reached,
      nextQty: next.qty,
    };
  }

  function paint(qty) {
    lastQty = qty;
    var blocks = document.querySelectorAll(BLOCK);
    for (var b = 0; b < blocks.length; b++) {
      var block = blocks[b];
      var cfg = config(block);
      if (!cfg) continue;
      var res = line(cfg, qty);
      if (!res) continue;

      var p = block.querySelector('[data-pf-next-tier]');
      if (p) p.textContent = res.text;
      var box = block.querySelector('[data-pf-next-tier-box]');
      if (box) box.classList.toggle('is-top', res.atTop);

      /* The rung the shopper is on and the rung one more jersey reaches, so the block and the
         sentence agree. Two states, not one: the card marks them differently on purpose, so
         "you are here" is never mistaken for "this is the goal". */
      var rungs = block.querySelectorAll('[data-pf-rung]');
      var nextEach = null;
      for (var r = 0; r < rungs.length; r++) {
        var q = parseInt(rungs[r].getAttribute('data-pf-rung'), 10);
        var isNext = !res.atTop && q === res.nextQty;
        rungs[r].classList.toggle('is-now', res.reached > 0 && q === res.reached);
        rungs[r].classList.toggle('is-next', isNext);
        if (isNext) nextEach = rungs[r].getAttribute('data-pf-each');
      }

      /* The money line. Both figures are strings Liquid already formatted onto the block and
         the rungs, so no currency is assembled here: a client-side "$" would be wrong the
         day the store sells in a second currency. Hidden at the top rung, where there is
         nothing to add, and on anything the snippet marked as having no price to quote. */
      var money = block.querySelector('[data-pf-next-money]');
      if (money) {
        var from = block.getAttribute('data-pf-base-money');
        var tpl = money.getAttribute('data-pf-tpl');
        if (block.hasAttribute('data-pf-no-money') || res.atTop || !nextEach || !from || !tpl) {
          money.hidden = true;
        } else {
          money.textContent = tpl
            .replace('[noun]', cfg.noun || 'jersey')
            .replace('[from]', from)
            .replace('[to]', nextEach);
          money.hidden = false;
        }
      }
    }
  }

  /* How many items in this cart the offer actually covers.

     cart.item_count counts everything, and the quantity discount in the Shopify admin runs on a
     jersey collection: a shopper who adds the MexicoPullover jacket to two jerseys would watch
     this block climb to "Best tier unlocked, 30%" for a rung checkout is never going to give
     them. The eligible product types are written onto the block by snippets/pf-offer.liquid,
     from the same theme setting the Liquid reads, so the two counts cannot drift.

     No list on the block means no restriction, which is a store with no exclusions. */
  function eligibleCount(cart, cfg) {
    var types = cfg && cfg.types;
    if (!types || !types.length) return cart.item_count;
    var items = cart.items || [];
    var n = 0;
    for (var i = 0; i < items.length; i++) {
      var t = String(items[i].product_type || '').trim().toLowerCase();
      if (types.indexOf(t) > -1) n += items[i].quantity;
    }
    return n;
  }

  function refresh() {
    var block = document.querySelector(BLOCK);
    if (!block) return;
    var cfg = config(block);
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c && typeof c.item_count === 'number') paint(eligibleCount(c, cfg)); })
      .catch(function () { /* the server-rendered line stands */ });
  }

  window.addEventListener('updated.ecomify.cart', refresh);

  /* The theme fires this from assets/product.js with the whole variant object. */
  window.addEventListener('variantChange.ecomify.product', function (e) {
    var v = e && e.detail;
    if (!v || !v.id) return;
    var blocks = document.querySelectorAll(BLOCK);
    for (var i = 0; i < blocks.length; i++) repriceTo(blocks[i], v.id);
    if (lastQty === null) refresh(); else paint(lastQty);
  });

  /* One read on load. The page can be served from a cache that predates the cart the shopper
     is actually carrying, and the whole point of this block is that the sentence is true. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
